/**
 * Category Mapping Constants
 *
 * This file contains all product category mappings based on Gender and Type combinations.
 * Used throughout the template builder for dynamic category selection.
 */

// Dynamic Category Options based on Gender and Type
export const CATEGORY_MAPPING = {
    // Men + Indian Wear
    'Men_Indianwear': [
        { value: 'All', label: 'All Indian Wear' },
        { value: 'Kurtas', label: 'Kurtas' },
        { value: 'Sherwanis', label: 'Sherwanis' },
        { value: 'Dhotis', label: 'Dhotis' },
        { value: 'Nehru Jackets', label: 'Nehru Jackets' },
        { value: 'Indo Western', label: 'Indo Western' },
        { value: 'Bandhgala', label: 'Bandhgala' },
        { value: 'Pathani Suits', label: 'Pathani Suits' },
        { value: 'Ethnic Jackets', label: 'Ethnic Jackets' },
        { value: 'Traditional Sets', label: 'Traditional Sets' }
    ],

    // Men + Western Wear
    'Men_Westernwear': [
        { value: 'All', label: 'All Western Wear' },
        { value: 'Shirts', label: 'Shirts' },
        { value: 'T-Shirts', label: 'T-Shirts' },
        { value: 'Jeans', label: 'Jeans' },
        { value: 'Trousers', label: 'Trousers' },
        { value: 'Blazers', label: 'Blazers' },
        { value: 'Suits', label: 'Suits' },
        { value: 'Shorts', label: 'Shorts' },
        { value: 'Hoodies', label: 'Hoodies' },
        { value: 'Sweaters', label: 'Sweaters' },
        { value: 'Jackets', label: 'Jackets' },
        { value: 'Polo Shirts', label: 'Polo Shirts' }
    ],

    // Women + Indian Wear
    'Women_Indianwear': [
        { value: 'All', label: 'All Indian Wear' },
        { value: 'Sarees', label: 'Sarees' },
        { value: 'Lehenga Choli', label: 'Lehenga Choli' },
        { value: 'Salwar Kameez', label: 'Salwar Kameez' },
        { value: 'Anarkali Suits', label: 'Anarkali Suits' },
        { value: 'Churidar', label: 'Churidar' },
        { value: 'Palazzo Sets', label: 'Palazzo Sets' },
        { value: 'Kurtis', label: 'Kurtis' },
        { value: 'Sharara Sets', label: 'Sharara Sets' },
        { value: 'Gharara Sets', label: 'Gharara Sets' },
        { value: 'Indo Western Gowns', label: 'Indo Western Gowns' },
        { value: 'Ethnic Crop Tops', label: 'Ethnic Crop Tops' },
        { value: 'Dupattas', label: 'Dupattas' }
    ],

    // Women + Western Wear
    'Women_Westernwear': [
        { value: 'All', label: 'All Western Wear' },
        { value: 'Dresses', label: 'Dresses' },
        { value: 'Tops', label: 'Tops' },
        { value: 'Blouses', label: 'Blouses' },
        { value: 'Skirts', label: 'Skirts' },
        { value: 'Pants', label: 'Pants' },
        { value: 'Jeans', label: 'Jeans' },
        { value: 'Jackets', label: 'Jackets' },
        { value: 'Jumpsuits', label: 'Jumpsuits' },
        { value: 'Co-ord Sets', label: 'Co-ord Sets' },
        { value: 'Blazers', label: 'Blazers' },
        { value: 'Sweaters', label: 'Sweaters' },
        { value: 'Hoodies', label: 'Hoodies' },
        { value: 'Shorts', label: 'Shorts' }
    ],

    // Kids + Indian Wear
    'Kids_Indianwear': [
        { value: 'All', label: 'All Kids Indian Wear' },
        { value: 'Boys Kurtas', label: 'Boys Kurtas' },
        { value: 'Girls Lehenga', label: 'Girls Lehenga' },
        { value: 'Kids Dhoti Sets', label: 'Kids Dhoti Sets' },
        { value: 'Girls Anarkali', label: 'Girls Anarkali' },
        { value: 'Boys Sherwanis', label: 'Boys Sherwanis' },
        { value: 'Girls Sharara', label: 'Girls Sharara' },
        { value: 'Kids Ethnic Sets', label: 'Kids Ethnic Sets' },
        { value: 'Traditional Frocks', label: 'Traditional Frocks' }
    ],

    // Kids + Western Wear
    'Kids_Westernwear': [
        { value: 'All', label: 'All Kids Western Wear' },
        { value: 'Boys Shirts', label: 'Boys Shirts' },
        { value: 'Girls Dresses', label: 'Girls Dresses' },
        { value: 'Boys T-Shirts', label: 'Boys T-Shirts' },
        { value: 'Girls Tops', label: 'Girls Tops' },
        { value: 'Boys Pants', label: 'Boys Pants' },
        { value: 'Girls Skirts', label: 'Girls Skirts' },
        { value: 'Boys Shorts', label: 'Boys Shorts' },
        { value: 'Girls Shorts', label: 'Girls Shorts' },
        { value: 'Kids Jeans', label: 'Kids Jeans' },
        { value: 'Kids Hoodies', label: 'Kids Hoodies' },
        { value: 'Kids Jackets', label: 'Kids Jackets' }
    ],

    // Unisex + Any Type
    'Unisex_Indianwear': [
        { value: 'All', label: 'All Unisex Indian Wear' },
        { value: 'Kurtas', label: 'Kurtas' },
        { value: 'Ethnic Wear', label: 'Ethnic Wear' },
        { value: 'Traditional Accessories', label: 'Traditional Accessories' }
    ],

    'Unisex_Westernwear': [
        { value: 'All', label: 'All Unisex Western Wear' },
        { value: 'T-Shirts', label: 'T-Shirts' },
        { value: 'Hoodies', label: 'Hoodies' },
        { value: 'Sweatshirts', label: 'Sweatshirts' },
        { value: 'Track Suits', label: 'Track Suits' }
    ],

    // Accessories (Gender Independent)
    'All_Accessories': [
        { value: 'All', label: 'All Accessories' },
        { value: 'Jewelry', label: 'Jewelry' },
        { value: 'Bags', label: 'Bags' },
        { value: 'Belts', label: 'Belts' },
        { value: 'Scarves', label: 'Scarves' },
        { value: 'Watches', label: 'Watches' },
        { value: 'Sunglasses', label: 'Sunglasses' },
        { value: 'Hair Accessories', label: 'Hair Accessories' },
        { value: 'Wallets', label: 'Wallets' }
    ],

    // Footwear (Gender Independent)
    'All_Footwear': [
        { value: 'All', label: 'All Footwear' },
        { value: 'Sandals', label: 'Sandals' },
        { value: 'Heels', label: 'Heels' },
        { value: 'Flats', label: 'Flats' },
        { value: 'Sneakers', label: 'Sneakers' },
        { value: 'Boots', label: 'Boots' },
        { value: 'Formal Shoes', label: 'Formal Shoes' },
        { value: 'Sports Shoes', label: 'Sports Shoes' },
        { value: 'Slippers', label: 'Slippers' }
    ],

    // Fusion (Gender Independent)
    'All_Fusion': [
        { value: 'All', label: 'All Fusion Wear' },
        { value: 'Indo Western', label: 'Indo Western' },
        { value: 'Fusion Dresses', label: 'Fusion Dresses' },
        { value: 'Contemporary Ethnic', label: 'Contemporary Ethnic' },
        { value: 'Modern Traditional', label: 'Modern Traditional' }
    ],

    // Default/Fallback
    'All_All': [
        { value: 'All', label: 'All Categories' },
        { value: 'Clothing', label: 'Clothing' },
        { value: 'Accessories', label: 'Accessories' },
        { value: 'Footwear', label: 'Footwear' }
    ]
};

export const GENDER_OPTIONS = [
    { value: 'All', label: 'All' },
    { value: 'Men', label: 'Men' },
    { value: 'Women', label: 'Women' },
    { value: 'Kids', label: 'Kids' },
    { value: 'Unisex', label: 'Unisex' }
];

export const TYPE_OPTIONS = [
    { value: 'All', label: 'All Types' },
    { value: 'Indianwear', label: 'Indian Wear' },
    { value: 'Westernwear', label: 'Western Wear' },
    { value: 'Fusion', label: 'Fusion Wear' },
    { value: 'Accessories', label: 'Accessories' },
    { value: 'Footwear', label: 'Footwear' }
];

export const STYLE_CATEGORY_OPTIONS = [
    { value: 'All', label: 'All Styles' },
    { value: 'Casual', label: 'Casual' },
    { value: 'Formal', label: 'Formal' },
    { value: 'Party', label: 'Party Wear' },
    { value: 'Traditional', label: 'Traditional' },
    { value: 'Contemporary', label: 'Contemporary' },
    { value: 'Vintage', label: 'Vintage' },
    { value: 'Bohemian', label: 'Bohemian' },
    { value: 'Minimalist', label: 'Minimalist' },
    { value: 'Luxury', label: 'Luxury' }
];

/**
 * Get filtered categories based on gender and type selection
 * @param {string} gender - Selected gender (Men, Women, Kids, etc.)
 * @param {string} type - Selected type (Indianwear, Westernwear, etc.)
 * @returns {Array} Array of category options
 */
export const getFilteredCategories = (gender, type) => {
    // Handle special cases for Accessories, Footwear, and Fusion
    if (type === 'Accessories') {
        return CATEGORY_MAPPING['All_Accessories'];
    }
    if (type === 'Footwear') {
        return CATEGORY_MAPPING['All_Footwear'];
    }
    if (type === 'Fusion') {
        return CATEGORY_MAPPING['All_Fusion'];
    }

    // Create key for mapping
    const key = `${gender}_${type}`;

    // Return specific mapping or fallback to default
    return CATEGORY_MAPPING[key] || CATEGORY_MAPPING['All_All'];
};
